import _ from 'lodash'
import type {UnitLengthTypesArray, UnitSize, UnitSizeType, UnitSizeTypesArray} from '@wix/document-services-types'
import type {CssValue} from '../../constants'
import {deserializeUnit, serializeUnit} from '../utils/unit'

const UNIT_SIZE_TYPES: UnitSizeTypesArray = [
    'px',
    'em',
    'rem',
    'fr',
    'percentage',
    'vh',
    'vw',
    'spx',
    'siteWidthPercentage'
]
const UNIT_LENGTH_TYPES: UnitLengthTypesArray = ['px', 'em', 'rem', 'vh', 'vw', 'vmin', 'vmax']
const TYPE_TO_UNIT = {
    percentage: '%'
}
const UNIT_TO_TYPE = _.invert(TYPE_TO_UNIT)

const convertTypeToUnit = (type: string) => (TYPE_TO_UNIT as Record<string, string>)[type] ?? type
const convertUnitToType = (unit: string) => UNIT_TO_TYPE[unit] ?? unit

const VALID_TYPES_SET = new Set([...UNIT_SIZE_TYPES, ...UNIT_LENGTH_TYPES].map(convertTypeToUnit))

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const type = convertTypeToUnit(val.type)
    return serializeUnit({value: val.value, type}, VALID_TYPES_SET)
}

const deserialize = (rule: CssValue): UnitSize | undefined => {
    const unit = deserializeUnit(rule, VALID_TYPES_SET)

    if (!unit) {
        return undefined
    }

    const type = convertUnitToType(unit.type) as UnitSizeType

    return {type, value: unit.value}
}

export default {
    serialize,
    deserialize
}
